import { render, staticRenderFns } from "./AdvisorCoreOptions.vue?vue&type=template&id=24ab5bac&scoped=true&"
import script from "./AdvisorCoreOptions.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab5bac",
  null
  
)

export default component.exports